export default {
  UPDATE_CART: 'UPDATE_CART',
  UPDATE_CART_INFO: 'UPDATE_CART_INFO',
  ADD_OFFER_MEAL: 'ADD_OFFER_MEAL',
  REMOVE_OFFER_MEAL: 'REMOVE_OFFER_MEAL',
  UPDATE_OFFER_MEAL: 'UPDATE_OFFER_MEAL',
  ADD_LUNCH_MEAL: 'ADD_LUNCH_MEAL',
  REMOVE_LUNCH_MEAL: 'REMOVE_LUNCH_MEAL',
  UPDATE_ORDER_DELIVERY_TYPE: 'UPDATE_ORDER_DELIVERY_TYPE',
  UPDATE_ORDER_PAYMENT_TYPE: 'UPDATE_ORDER_PAYMENT_TYPE',
  UPDATE_FIRSTNAME: 'UPDATE_FIRSTNAME',
  UPDATE_LASTNAME: 'UPDATE_LASTNAME',
  UPDATE_EMAIL: 'UPDATE_EMAIL',
  UPDATE_PHONE: 'UPDATE_PHONE',
  UPDATE_ADDRESS: 'UPDATE_ADDRESS',
  UPDATE_NOTE: 'UPDATE_NOTE',
}
